<form class="needs-validation" [formGroup]="myForm" novalidate>
      <app-validation-banner [form]="myForm" [show]="showBanner"></app-validation-banner>
    <app-form-base [myForm]="myForm" [request]="request" [duplicated]="duplicated" [group]="GROUP" (newModel)="updateRequest($event)" [new]="NEW" (newOptFile)="updateOptFile($event)"  ></app-form-base>
   
    <label for ="description"> <p class="bold pad-left no-pad">Request Details</p></label>
    <p class="no-pad pad-left">Please be specific about your request.</p>
    <div class = "text-pad">
    <textarea class="col-12  fit" maxlength="5000" id="description" formControlName = "requestDetails" rows="10">
 
  </textarea>
   </div>
    <p class="err pad-left" *ngIf="myForm.controls.requestDetails.errors?.required && myForm.controls.requestDetails.touched">
       Request Details are required
    </p>
    <p class="no-pad gray pad-left">{{myForm.controls.requestDetails.value.length}}  of 5,000 characters</p>
    <label class="bold pad-left">Attach Document 
       <span class="optional-tag no-bold"> (optional)</span>
    </label> 
    <p class = "no-pad pad-left">If you have additional documents you would like to upload you can do so here.</p>
    <app-opt-file-upload [myForm]="myForm" *ngIf="optDocs" [optDocs]="optDocs"  (newOptFile)="updateOptFile($event)"> </app-opt-file-upload>
 </form>
 <app-add-request-button [group]="true" [reqType]="reqToggle" [validated]="myForm.touched" (close)="closeParent($event)" (submit)="submit($event)"></app-add-request-button>
